import '@babel/polyfill';
// Transpiler for older browsers
import 'core-js/stable';
// optional but required for transforming generator fns.
import 'regenerator-runtime/runtime';
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import $ from 'jquery';
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: sessionStorage.getItem('token') || '',
        user: {}
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading';
        },
        auth_success(state, token, user) {
            state.status = 'success';
            state.token = token;
            state.user = user;
        },
        auth_error(state) {
            state.status = 'error';
        },
        logout(state) {
            state.status = '';
            state.token = '';
        },
    },
    actions: {
        preAuthentication({ commit }, user) {
            var headers = {
                'headers': {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`
                }
            };
            return new Promise((resolve, reject) => {
                commit('auth_request');
                axios.post(`api/account/preauth/${user.id}`, null, headers)
                    .then(resp => {
                        sessionStorage.setItem("externalLogin", user.cliLogSource);
                        sessionStorage.setItem("clientID", resp.data.cliID);
                        sessionStorage.setItem("cliLoginID", resp.data.cliLoginId);
                        sessionStorage.setItem("welcome", "Welcome " + resp.data.fullName);
                        const token = resp.data.token;
                        sessionStorage.setItem('token', token);
                        // Add the following line:
                        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                        commit('auth_success', token, resp.data);
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('auth_error');
                        sessionStorage.removeItem('token');
                        reject(err);
                    });
            })
        },
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios.post('api/account/auth', {
                    'cliLoginId': user.userId,
                    'cliPassword': user.userPassword
                })
                    .then(resp => {
                        if (!resp || !resp.data) {
                            commit('auth_error');
                            sessionStorage.removeItem('token');
                            reject('Invalid login id or password.');
                        } else {
                            try {
                                sessionStorage.setItem("clientID", resp.data.cliID);
                                sessionStorage.setItem("cliLoginID", resp.data.cliLoginId);
                                sessionStorage.setItem("welcome", "Welcome " + resp.data.fullName);
                                const token = resp.data.token;
                                sessionStorage.setItem('token', token);
                                // Add the following line:
                                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                                commit('auth_success', token, resp.data);
                                resolve(resp);
                            } finally {
                                let data = $.extend(true, {}, resp.data);
                                data.token = null;
                                data.cliLogSource = 'client.xstek.net';
                                axios.post('api/account/log', data);
                            }
                        }
                    })
                    .catch(err => {
                        commit('auth_error');
                        sessionStorage.removeItem('token');
                        reject(err);
                    });
            })
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout');
                var externalLogin = sessionStorage.getItem('externalLogin');
                sessionStorage.removeItem('clientID');
                sessionStorage.removeItem('cliLoginID');
                sessionStorage.removeItem('welcome');
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('externalLogin');
                sessionStorage.clear();
                delete axios.defaults.headers.common['Authorization'];
                resolve(externalLogin);
            })
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
    }
})
